export const TRAINING_LIST_PAGE_SIZE = 12;

export function trainingListTotalPages(
  length: number,
  pageSize = TRAINING_LIST_PAGE_SIZE,
): number {
  return Math.max(1, Math.ceil(length / pageSize));
}

export function sliceTrainingListPage<T>(
  items: T[],
  page: number,
  pageSize = TRAINING_LIST_PAGE_SIZE,
): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}
